/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { ErrorHandler, Injectable, inject } from '@angular/core'
import { NewRelicService } from '@myprofile-ui/pidx-utils'

@Injectable({
  providedIn: 'root',
})
export class NewRelicErrorHandler implements ErrorHandler {
  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(private newRelicService: NewRelicService) {}

  handleError(error: any): void {
    this.newRelicService.noticeError(error)
  }
}
